import type {ChakraProviderProps} from '@chakra-ui/react';
import {ChakraProvider} from '@chakra-ui/react';
import React from 'react';

import {theme} from '../../theme-config';
import {Toast} from '../Toast/Toast';

export const UIThemeProvider = (props: ChakraProviderProps) => (
  <ChakraProvider
    toastOptions={{
      defaultOptions: {
        position: `bottom-right`,
        orientation: `horizontal`,
        render: Toast,
      },
    }}
    theme={theme}
    {...props}
  />
);
